import React from 'react';
import './Quality.css';
import { FaCheckCircle } from 'react-icons/fa';

const QualityPolicy = () => {
  return (
    <div className="quality-section pt-100 pb-100">
      <div className="container">
        <div className="row justify-content-center mb-4">
          <div className="col-lg-8 text-center">
            <h3 className="quality-title">Quality Policy</h3>
            <p className="quality-subtitle">
             As a company we are committed towards quality and customer satisfaction to that end we have series of policies and processes in place.

            </p>
          </div>
        </div>

        <div className="row text-center">
          <div className="col-sm-6 col-lg-4 mb-4">
            <div className="quality-box">
              <FaCheckCircle className="quality-icon" />
              <h5 className="quality-box-title">A highly monitored management system</h5>
              <p className="quality-box-text"></p>
            </div>
          </div>
          <div className="col-sm-6 col-lg-4 mb-4">
            <div className="quality-box">
              <FaCheckCircle className="quality-icon" />
              <h5 className="quality-box-title">Adhering to statutory and legal compliance</h5>
              <p className="quality-box-text"></p>
            </div>
          </div>
          <div className="col-sm-6 col-lg-4 mb-4">
            <div className="quality-box">
              <FaCheckCircle className="quality-icon" />
              <h5 className="quality-box-title">Developing a good working environment</h5>
              <p className="quality-box-text"></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QualityPolicy;
